import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImageVideoComponent } from './image-video/image-video.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MediaCaptureDialogComponent } from './media-capture-dialog/media-capture-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputModule } from '@input/input.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { DataModule } from '@data/data.module';
import { ImageScaleTrayComponent } from './image-scale-tray/image-scale-tray.component';

@NgModule({
  declarations: [
    ImageVideoComponent,
    ImageScaleTrayComponent,
    MediaCaptureDialogComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatIconModule,
    MatButtonModule,
    MatSelectModule,
    MatProgressBarModule,
    InputModule,
    DataModule
  ],
  exports: [
    ImageVideoComponent,
    ImageScaleTrayComponent,
  ]
})
export class MediaModule { }
